﻿export class InsulationSpecification {
    field: string;
    exists: boolean;
    value: string;
    displayOrder: number;
    footnote: string;
    values: InsulationSpecification[];
}
